<template>
  <fragment>
    <div class="ShareModal">
      <div class="title">
        <div>{{ "Share this " + terminology }}</div>
        <div class="close" @click="$store.commit('setShare', false)">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="35"
            height="35"
            viewBox="0 0 35 35"
          >
            <g fill-rule="evenodd">
              <path
                d="M-5.147 15.441L40.147 15.441 40.147 19.559 -5.147 19.559z"
                transform="rotate(-45 17.5 17.5)"
              />
              <path
                d="M-5.147 15.441L40.147 15.441 40.147 19.559 -5.147 19.559z"
                transform="rotate(-135 17.5 17.5)"
              />
            </g>
          </svg>
        </div>
      </div>

      <div class="url">
        <input ref="input" :placeholder="location" disabled />
        <div :class="{ copy: true, copied }" @click="copy">
          <div>{{ copied ? "COPIED!" : "COPY" }}</div>
        </div>
      </div>
    </div>
    <div
      class="cover"
      v-if="$store.state.ui.share"
      @click="$store.commit('setShare', false)"
    ></div>
  </fragment>
</template>

<script>
export default {
  name: "ShareModal",
  props: {
    terminology: String
  },
  data() {
    return {
      copied: false
    };
  },
  computed: {
    location() {
      return window.location.href;
    }
  },
  methods: {
    copy() {
      var dummy = document.createElement("input"),
        text = window.location.href;

      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");

      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 4000);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/constants/_variables.scss";

.cover {
  position: fixed;
  top: 0px;
  left: 0px;
  height: 100vh;
  width: 100vw;
  z-index: 10;
}

.ShareModal {
  z-index: 102;
  background-color: $light-gold;
  width: 472px;
  position: absolute;
  right: 0px;
  top: 0px;
  padding-left: 1em;
  padding-right: 1em;
  padding-bottom: 1em;
  padding-top: 1em;

  @media (max-width: 815px) {
    width: calc(100vw - 4em);
  }

  .title {
    color: black;
    font-size: 20px;
    text-transform: uppercase;
    font-weight: 500;
    margin-bottom: 1em;

    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 11;

    .close {
      height: 18px;

      svg {
        height: 100%;
      }

      &:hover {
        font-weight: 600;
        cursor: pointer;

        path {
          fill: $copper !important;
        }
      }
    }
  }

  .url {
    z-index: 11;
    display: flex;

    input {
      flex-grow: 1;
      margin-right: 1em;
      padding-left: 1em;
    }
  }

  .copy {
    width: 109px;
    height: 40px;
    background-color: $copper;
    font-style: italic;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &.copied {
      background-color: $brown-grey;
    }

    &:not(.copied):hover {
      color: $light-gold;
      font-weight: bold;
    }
  }
}
</style>
